var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiquidityPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1429_5229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.154 50.8926C39.0553 50.8926 36.3594 52.6077 34.957 55.1388V61.1739C39.4996 61.1739 43.1821 57.4914 43.1821 52.9488V50.8926H42.154Z",
    fill: "url(#paint0_linear_1429_5229)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1429_5229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1527 46.6094C40.7629 46.6094 36.9437 49.0392 34.957 52.6249V61.1746C41.3923 61.1746 46.6092 55.9577 46.6092 49.5224V46.6094H45.1527Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1527 46.6094C40.7629 46.6094 36.9437 49.0392 34.957 52.6249V61.1746C41.3923 61.1746 46.6092 55.9577 46.6092 49.5224V46.6094H45.1527Z",
    fill: "url(#paint1_linear_1429_5229)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.557 60.5586V52.7822C37.4626 49.4526 41.0449 47.2094 45.1527 47.2094H46.0092V49.5224C46.0092 55.4251 41.382 60.247 35.557 60.5586Z",
    stroke: "url(#paint2_linear_1429_5229)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.956 36.4136C34.956 35.6092 34.3046 34.957 33.4995 34.957C32.6944 34.957 32.043 35.6092 32.043 36.4136V65.544C32.043 66.3484 32.6944 67.0005 33.4995 67.0005C34.3046 67.0005 34.956 66.3484 34.956 65.544V61.1744V52.6247V36.4136Z",
    fill: "url(#paint3_linear_1429_5229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8928 4.37012H13.1102C13.1102 9.19662 9.1976 13.1092 4.37109 13.1092V30.5875C9.1976 30.5875 13.1102 34.5001 13.1102 39.3266H53.8928C53.8928 34.5001 57.8055 30.5875 62.632 30.5875V13.1092C57.8055 13.1092 53.8928 9.19662 53.8928 4.37012Z",
    fill: "url(#paint4_linear_1429_5229)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_1429_5229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5435 43.6957H1.45652C0.652158 43.6957 0 43.0435 0 42.2391V1.45652C0 0.652158 0.652158 0 1.45652 0H65.5435C66.3478 0 67 0.652158 67 1.45652V42.2391C67 43.0435 66.3478 43.6957 65.5435 43.6957Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5435 43.6957H1.45652C0.652158 43.6957 0 43.0435 0 42.2391V1.45652C0 0.652158 0.652158 0 1.45652 0H65.5435C66.3478 0 67 0.652158 67 1.45652V42.2391C67 43.0435 66.3478 43.6957 65.5435 43.6957Z",
    fill: "url(#paint5_linear_1429_5229)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5435 43.0957H1.45652C0.983528 43.0957 0.6 42.7121 0.6 42.2391V1.45652C0.6 0.983528 0.983528 0.6 1.45652 0.6H65.5435C66.0165 0.6 66.4 0.983529 66.4 1.45652V42.2391C66.4 42.7121 66.0165 43.0957 65.5435 43.0957Z",
    stroke: "url(#paint6_linear_1429_5229)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1429_5229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8928 4.37012H13.1102C13.1102 9.19662 9.1976 13.1092 4.37109 13.1092V30.5875C9.1976 30.5875 13.1102 34.5001 13.1102 39.3266H53.8928C53.8928 34.5001 57.8055 30.5875 62.632 30.5875V13.1092C57.8055 13.1092 53.8928 9.19662 53.8928 4.37012Z",
    fill: "white",
    fillOpacity: 0.16
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1429_5229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5003 32.0436C39.1312 32.0436 43.696 27.4789 43.696 21.848C43.696 16.2171 39.1312 11.6523 33.5003 11.6523C27.8694 11.6523 23.3047 16.2171 23.3047 21.848C23.3047 27.4789 27.8694 32.0436 33.5003 32.0436Z",
    fill: "white",
    fillOpacity: 0.16
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_1429_5229",
    x: 10.957,
    y: 22.6094,
    width: 59.6523,
    height: 62.5654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5229",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_1429_5229",
    x: -24,
    y: -24,
    width: 115,
    height: 91.6953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5229",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1429_5229",
    x: 4.37109,
    y: 4.37012,
    width: 58.2607,
    height: 42.9561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1429_5229",
    x: 23.3047,
    y: 11.6523,
    width: 20.3916,
    height: 28.3916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5229"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_5229",
    x1: 35.2997,
    y1: 52.9488,
    x2: 44.3272,
    y2: 53.9519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1429_5229",
    x1: 35.4425,
    y1: 49.5224,
    x2: 48.2315,
    y2: 50.9434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1429_5229",
    x1: 35.3212,
    y1: 47.2714,
    x2: 46.6092,
    y2: 47.2714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1429_5229",
    x1: 32.1643,
    y1: 41.3657,
    x2: 35.4005,
    y2: 41.4066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1429_5229",
    x1: 6.79863,
    y1: 11.3614,
    x2: 68.2406,
    y2: 25.5841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1429_5229",
    x1: 2.79167,
    y1: 8.73914,
    x2: 74.0063,
    y2: 23.9052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1429_5229",
    x1: 2.09375,
    y1: 1.98617,
    x2: 67,
    y2: 1.98617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1429_5229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidityPool);
export default __webpack_public_path__ + "static/media/liquidity-pool.e7cd3fc3e30d18d0220869a8050fa056.svg";
export { ForwardRef as ReactComponent };